export const potvrda_o_radnom_odnosu= {
    templateId: 234,
    category: 3,
    templateTitle: 'Potvrda o radnom odnosu',
    templateDescription: `<p>Potvrdu o radnom odnosu poslodavac izdaje radniku na njegov zahtjev/molbu, a radi ostvarenja određenih prava radnika.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Radi ostvarenja određenih prava (npr. upis djece u vrtić i sl.), radnik svoj radnopravni status dokazuje potvrdom o radnom odnosu (tzv. "potvrda o zaposlenju") koju izdaje poslodavac na zahtjev/molbu radnika.</p>
    <p>Ovu potvrdu o radnom odnosu ("potvrdu o zaposlenju") vrijedi razlikovati od potvrde o vrsti i trajanju radnog odnosa koju možete vidjeti <a class="local-link" href="/contract?template=35">ovdje</a>, a koju je poslodavac dužan izdati na na zahtjev radnika odnosno kod prestanka radnog odnosa. </p>
  `,
  sides: [
    {
      signature: 'Za Poslodavca:',
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      suffix: " (u daljnjem tekstu: Poslodavac),",
    }
  ],

  headline: 'izdaje sljedeću',
  title: 'POTVRDU O RADNOM ODNOSU',

  noArticleNumbers: true,

  articles: [
    {
        title: '',
        mandatory: true,
        statements: [
            {
                type: 'input',
                mandatory: true,
                parts: [
                    { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                    { type: "text", content: "," },
                    { type: 'text', content: 'iz',},
                    { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                    { type: 'text', content: ',' },
                    { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                    { type: "text", content: "," },
                    { type: 'text', content: 'OIB:' },
                    { type: 'input', value: '', required: true, },
                    { type: 'text', content: '(u daljnjem tekstu: Radnik)' },
                        { type: 'text', content: ', zaposlen je kod Poslodavca počevši od' },
                        { type: 'input', value: '', required: true,  },
                        {type: 'text', content: 'godine,'},
                        {type: 'text', content: 'u'},
                        {type: 'input', value: '', required: true, help: "Upisati naznaku da li je radnik za poslen u punom ili nepunom radnom vremenu."  },
                    {type: 'text', content: ', na temelju Ugovora o radu na'},
                    {type: 'input', value: '', required: true,  help: "Upisati naznaku da li je radnik zaposlen na određeno ili neodređeno vrijeme."  },
                    {type: 'text', content: 'vrijeme.'},
                ],
            }],
        value: '',
    },
      {
        title: '',
        mandatory: true,
        statements: [
            {
                type: 'input',
                mandatory: true,
                parts: [
                    { type: 'text', content: 'Ova potvrda izdaje se u svrhu:',},
                    { type: 'textarea', value: '', required: true, placeholder: "Npr. u svrhu  ostvarivanja prednosti pri upisu u vrtić/jaslice "   },
                ],
            }],
        value: '',
    },
    {
        title: '',
        mandatory: true,
        exampleContent: true,
        statements: [
            {
                type: 'text',
                required: true,
                mandatory: true,
                editable: true,
                content: 'Ova potvrda se ne smije upotrijebiti u drugu svrhu, osim u onu za koju je izdana.',
                value: '',
                            },
        ],
        value: '',
    },
    {
      mandatory: true,
      static: true,
      type: 2, // date and place
      statements: [
        {
          type: "input",
          mandatory: true,
          parts: [
            {
              type: "text",
              content: "U"
            },
            {
              type: "input",
              value: "",
              placeholder: "Upišite mjesto.",
              required: true,
            },
            {
              type: "text",
              content: ", dana"
            },
            {
              type: "date",
              value: new Date(),
              required: true
            },
            {
              type: "text",
              content: "godine."
            }
          ]
        },
      ]
    },
    {
      mandatory: true,
      static: true,
      type: 3,  // signature
      statements: [],
    },
    {
      static: true,
      mandatory: false,
      type: 4, 
      statements: [
        {
          type: 'text',
          mandatory: true,
          editable: true,
          content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska evidencija',
          help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
        }
      ]
    },
  ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/234_potvrda_o_radnom_odnosu.ts